import type { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  InfoBanner,
} from '@kanda-libs/ks-design-library';

import PageTitle from 'components/shared/PageTitle';

import PartnerTable from '../PartnerTable';
import PartnersActions from '../PartnersActions';
import PartnersAnalaytics from '../PartnersAnalytics';

const PartnersListPage: FunctionComponent = function () {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Partners</PageTitle>
        <InfoBanner title="Partners" backArrow={false} />
        <PartnersActions />
        <PartnersAnalaytics />
        <PartnerTable />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default PartnersListPage;
